var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',{attrs:{"containers":_vm.containers},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('HomeHeroBar',{attrs:{"section":'home5'},on:{"gradientButtonClicked":_vm.scrollToCGTCalculator}})]},proxy:true},{key:"intro",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('TitleRow',{attrs:{"html":true,"title":`<p style='
          font-weight: 300;
          font-size: 28px;
          line-height: 34px;
          letter-spacing: -0.25%;
          text-align: center;
          color:#282828;
       '>
       Capital Gains Tax (CGT) Calculator
       </p>`,"description":`<p style='
        font-weight: 400;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
       '>
        CGT is a tax you pay on the profit from selling property or investments. 
        <span style='
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
        '>
        CGT also applies when you pass away.</span>
        In this case SARS treats your assets as if you’d sold them, 
        <span style='
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
        '>
        which can significantly reduce what your loved ones inherit.</span>
       </p>
       <p style='
        font-weight: 400;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0%;
        text-align: center;
        color:#1E1E1E;
       '>Complete the details below to calculate your CGT.</p>`}})],1)]},proxy:true},{key:"capital-gains-calculator",fn:function(){return [_c('div',{ref:"CGTCalculator"},[_c('CapitalTaxGainsCalculator',{attrs:{"customLandingPage":true},on:{"scrollToOtherCosts":_vm.scrollToOtherCosts}})],1)]},proxy:true},{key:"info-title-row",fn:function(){return [_c('div',{ref:"otherCosts",staticClass:"section-padding"},[_c('InfoTilesContainer',{attrs:{"tiles":_vm.infoTiles,"buttonText":'CREATE MY WILL NOW',"alternativeTitle":`<p style='
                font-weight: 500;
                font-size: 28px;
                line-height: 32px;
                letter-spacing: -0.23px;
                text-align: center;
                color:#282828;
                    '>
                    The other costs <span style='font-weight: 300;'>your estate could face</span>, and how to avoid them
                    </p>
                        <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>
             When you pass away, CGT is just one of the costs and taxes affecting your estate. Others include:</p>`,"additionalText":`  <p style='
              margin:48px 0 35px 0;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 22px;
              text-align: center;
              color:#747474;
              '>An estate plan, documented in a legally valid will, can help reduce these costs and preserve more for your loved ones.</p>`},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"why-choose-us",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('ImageTextBanner',{attrs:{"imageUrl":_vm.whitelabel.images.home4ReduceCostsImage,"title":`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 34px;
              letter-spacing: -0.25%;
              color:#282828;
            '>Why not having a will places your loved ones at risk`,"paragraphOne":`<p style='
                font-weight: 600;
                font-size: 16px;
                line-height: 28px;
                letter-spacing: 0%;
                color:#282828;
                '>
               Without a will:
               </p>
            <ul class='list-disc'
            style='line-height: 28px;'
            >
       <li>The law decides who inherits.</li>
       <li>Your family could face delays and disputes.</li>
       <li>Estate duty, executor’s fees, and CGT can quickly shrink your estate — even force the sale of property.</li>
            </ul>
            <p style='
            margin-top:24px;
            font-weight: 300;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 0%;
            color:#282828;
            '>
           A will makes your wishes clear and helps protect your loved ones from unnecessary costs and stress.
            </p>
`,"reversed":true,"buttonText":'CREATE MY WILL NOW',"bottomMargin":true},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"create-your-will-info",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('InfoTilesContainer',{attrs:{"tiles":_vm.infoTilesCreateYourWill,"buttonText":'CREATE MY FREE WILL',"alternativeTitle":`<p style='
              font-weight: 500;
              font-size: 28px;
              line-height: 32px;
              letter-spacing: -0.23px;
              text-align: center;
            '>
            How to create a will with Old Mutual
            </p>`,"additionalText":`
            <p style='
            font-weight: 400;
            font-style: Regular;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            color:#747474;
            '>
            When you create your will, <span
            style='font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>
          you also get access to EstateAssist</span> — personalised
            insurance cover that <span style='
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0%;
            text-align: center;
            '>shields your loved ones from costly estate 
            fees and taxes including Capital Gains Tax.</span>
            </p>
            `},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"create-your-will-banner",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('CreateYourWillBanner',{attrs:{"alternativeBanner":true,"bannerText":`<p style='
              font-weight: 600;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>Join 23,000+ South Africans 
            <span style='
              font-weight: 300;
              font-size: 28px;
              line-height: 36px;
              text-align: center;
            '>who’ve created their wills online with Old Mutual since 2023</span>
            </p>`,"pb0":true}})],1)]},proxy:true},{key:"take-control",fn:function(){return [_c('div',{staticClass:"section-padding"},[_c('ImageTextBanner',{attrs:{"imageUrl":_vm.whitelabel.images.home1JoinUsImage,"title":`<p style='
                font-weight: 600;
                font-size: 28px;
                line-height: 36px;
                color:#282828;
                '>
              You’ve seen what Capital Gains Tax could cost your estate.
                </p>`,"paragraphOne":`
            <p style='
            font-weight: 300;
            font-size: 28px;
            line-height: 36px;
              color:#282828;
            '>
          Protect your loved ones from unnecessary financial stress — create your will with Old Mutual.
            </p>`,"reversed":true,"buttonText":'CREATE MY WILL',"bottomMargin":true},on:{"gradientButtonClicked":_vm.createYourWill}})],1)]},proxy:true},{key:"callusback",fn:function(){return [(_vm.whitelabel.brand !== 'quickwill')?_c('EstateAdministrationCostCalculatorFooter',{on:{"requestACall":_vm.requestACall}}):_vm._e()]},proxy:true}])}),_vm._v(" "),_c('SuccessSnackbar',{attrs:{"message":_vm.alertMessage},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}}),_vm._v(" "),_c('RequestACallDialog',{attrs:{"showRequestACallDialog":_vm.showRequestACallDialog},on:{"update:showRequestACallDialog":function($event){_vm.showRequestACallDialog=$event},"update:show-request-a-call-dialog":function($event){_vm.showRequestACallDialog=$event},"success":_vm.showSuccessMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }